import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AuthHeaderInterceptorService implements HttpInterceptor {
  /**
   * @method intercept - Identifies and handles a given HTTP request.
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const accesToken = localStorage.getItem("JWTtoken")
      ? "Bearer " + localStorage.getItem("JWTtoken")
      : "null";
    const myAuthToken = accesToken;
    const authReq = request.clone({
      setHeaders: { Authorization: myAuthToken },
    });

    return next.handle(authReq);
  }
}
